// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e074a432","container":"_737c8c66"};